export default function SelectDateValidations(values: any) {
  let errors: any = {};

  return errors;
}
